import { FeatureFlag } from '@/src/types/common'

type GrowthBookLike = { getFeatureValue: (key: string, fallback: string[]) => string[] } | null | undefined

/**
 * Role handles permitted to access Ask GYG, sourced from the `askgyg-bhyve-roles`
 * flag (a JSON array of role handles, e.g. ["COC", "SCOC"]). Fails closed: an
 * absent, empty, or malformed flag yields no allowed roles, denying everyone.
 */
export function getAskGygAllowedRoleHandles(growthbook?: GrowthBookLike): string[] {
  const value = growthbook?.getFeatureValue(FeatureFlag.ASK_GYG_ROLES, [])

  return Array.isArray(value) ? value.filter((handle): handle is string => typeof handle === 'string') : []
}

/** Whether the given role handle is in the Ask GYG allow-list. */
export function isAskGygRoleAllowed(roleHandle: string | undefined, allowedRoleHandles: string[]): boolean {
  return !!roleHandle && allowedRoleHandles.includes(roleHandle)
}
